import React, { useEffect, useMemo, useState } from "react";
import { AgGridReact } from "ag-grid-react";

import { Link, useNavigate, useParams } from "react-router-dom";
import {
  pointsdelete,
  pointsupdate,
  pointswholedelete,
  pooldetails,
  tourcategorydetail,
  tourpointslist,
  tourviewdetail,
} from "../../../../services/superadmin";
import { crmtourviewdetail } from "../../../../services/cityregionaladmin";
import { scheadtourviewdetail } from "../../../../services/schoolhead";
import { Reftourdetail } from "../../../../services/referee";
import dotracking from "../../../trackinglogs";
import trackobj from "../../../trackingpages.json";
import { tourdetails } from "../../../../services/register";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { coachtourviewdetail } from "../../../../services/coach";

export const PointsList = () => {
  const { id, eid, tid } = useParams();
  const [filterProduct, setFilterProduct] = useState([]);
  const [plname, setPName] = useState("");

  const sorting = useMemo(() => {
    return ["asc", "desc"];
  }, []);

  const columnDefs = [
    {
      headerName: "Team Name",
      field: "team_name",
      width: 200,
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Played",
      field: "matches_played",
      width: 120,
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      editable: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Won",
      field: "matches_won",
      width: 120,
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      editable: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Lost",
      field: "matches_lost",
      width: 120,
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      editable: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Draw",
      field: "matches_draw",
      width: 120,
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      editable: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "GF",
      field: "gf",
      width: 120,
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      editable: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "GA",
      field: "ga",
      width: 120,
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      editable: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "GD",
      field: "gd",
      width: 120,
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      editable: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Points",
      field: "points",
      width: 120,
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      editable:true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Status",
      field: "match_status",
      width: 120,
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      editable:true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Actions",
      field: "id",
      width: 100,
      sortable: false,
      resizable: false,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              title="Edit Points"
              onClick={() => handleshow(params.value,params.data)}
              className="btn-sm btn-success me-1"
            >
              <i className="fa fa-edit fa-lg"></i>
            </a>
            <a
              title="Delete Points"
              onClick={() => deletepts(params.value, params.data)}
              className="btn-sm btn-danger"
            >
              <i className="fa fa-trash fa-lg"></i>
            </a>
          </div>
        );
      },
    },
  ];

  const columnCDefs = [
    {
      headerName: "Team Name",
      field: "team_name",
      width: 200,
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Played",
      field: "matches_played",
      width: 120,
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      editable: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Won",
      field: "matches_won",
      width: 120,
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      editable: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Lost",
      field: "matches_lost",
      width: 120,
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      editable: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Draw",
      field: "matches_draw",
      width: 120,
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      editable: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "NR",
      field: "nr",
      width: 120,
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      editable: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "NRR",
      field: "nrr",
      width: 120,
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      editable: true,
      cellStyle: { textAlign: "left" },
    },
  
    {
      headerName: "Points",
      field: "points",
      width: 120,
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      editable:true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Status",
      field: "match_status",
      width: 120,
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      editable:true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Actions",
      field: "id",
      width: 100,
      sortable: false,
      resizable: false,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              title="Edit Points"
              onClick={() => handleshow(params.value,params.data)}
              className="btn-sm btn-success me-1"
            >
              <i className="fa fa-edit fa-lg"></i>
            </a>
            <a
              title="Delete Points"
              onClick={() => deletepts(params.value, params.data)}
              className="btn-sm btn-danger"
            >
              <i className="fa fa-trash fa-lg"></i>
            </a>
          </div>
        );
      },
    },
  ];

  const columnChDefs = [
    {
      headerName: "Team Name",
      field: "team_name",
      width: 200,
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Played",
      field: "matches_played",
      width: 120,
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      editable: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Won",
      field: "matches_won",
      width: 120,
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      editable: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Lost",
      field: "matches_lost",
      width: 120,
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      editable: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Draw",
      field: "matches_draw",
      width: 120,
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      editable: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Points",
      field: "points",
      width: 120,
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      editable:true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Status",
      field: "match_status",
      width: 120,
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      editable:true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Actions",
      field: "id",
      width: 100,
      sortable: false,
      resizable: false,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              title="Edit Points"
              onClick={() => handleshow(params.value,params.data)}
              className="btn-sm btn-success me-1"
            >
              <i className="fa fa-edit fa-lg"></i>
            </a>
            <a
              title="Delete Points"
              onClick={() => deletepts(params.value, params.data)}
              className="btn-sm btn-danger"
            >
              <i className="fa fa-trash fa-lg"></i>
            </a>
          </div>
        );
      },
    },
  ];
  function handleshow(hid,hdata) {
    if(hdata !== null){
      const temp = new FormData();
      temp.append("admin_id",localStorage.getItem('UID'));
      temp.append("matches_played",hdata.matches_played)
      temp.append("matches_won",hdata.matches_won)
      temp.append("matches_lost",hdata.matches_lost)
      temp.append("matches_draw",hdata.matches_draw)
      temp.append("gf",hdata.gf ? hdata.gf : 0)
      temp.append("ga",hdata.ga ? hdata.ga : 0)
      temp.append("gd",hdata.gd ? hdata.gd : 0)
      temp.append("nr",hdata.nr ? hdata.nr : 0)
      temp.append("nrr",hdata.nrr ? hdata.nrr : 0)
      temp.append("points",hdata.points)
      temp.append("match_status",hdata.match_status)
      temp.append("points_table_id",hid)
      pointsupdate(temp).then((res) => {
        if (res.status === true) {
          toast.success(res.message);
          listall();
        }
      });
    }
    


  }
  function deletepts(did, dname) {
    Swal.fire({
      title: "Are you sure want to delete?",
      showCancelButton: true,
      confirmButtonColor: "#d71635",
      confirmButtonText: "Ok",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        const tempData = new FormData();
        tempData.append("id", did);
        dotracking(
          dname.team_name +
            " delete icon in points list for " +
            catname +
            " (" +
            eid +
            ") category in " +
            tname +
            " (" +
            id +
            ") tournament $$ " +
            trackobj.pointlistheading
        );
        pointsdelete(tempData).then((res) => {
          if (res.status === true) {
            toast.success(res.message);
            listall();
          }
        });
      }
    });
  }

  const navigate = useNavigate();
  const [tname, setTName] = useState("");
  const [catname, setCatname] = useState("");
  const [sports,setSports]=useState("");
  useEffect(() => {
    listall();
    const tempData = new FormData();
    tempData.append("category_id", eid);
    tourcategorydetail(tempData).then((res) => {
      if (res.status === true) {
        setCatname(res.data.category_details.category_name);
      }
    });
    if (localStorage.getItem("Role") === "1") {
      tourviewdetail(id).then((response) => {
        if (response.status === true && response.data.tournament !== null) {
          setTName(response.data.tournament.meet_name);
          setSports(response.data.tournament.sports_type);
        }
      });
    } else if (localStorage.getItem("Role") === "3") {
      crmtourviewdetail(id).then((response) => {
        if (response.status === true && response.data.tournament !== null) {
          setTName(response.data.tournament.meet_name);
          setSports(response.data.tournament.sports_type);
        }
      });
    } else if (localStorage.getItem("Role") === "4") {
      scheadtourviewdetail(id).then((response) => {
        if (response.status === true && response.data.tournament !== null) {
          setTName(response.data.tournament.meet_name);
          setSports(response.data.tournament.sports_type);
        }
      });
    } else if (localStorage.getItem("Role") === "5") {
      Reftourdetail(id).then((response) => {
        if (response.status === true && response.data.tournament !== null) {
          setTName(response.data.tournament.meet_name);
          setSports(response.data.tournament.sports_type);
        }
      });
    } else if (localStorage.getItem("Role") === "6") {
      tourdetails(id).then((response) => {
        if (response.status === true && response.data.tournament !== null) {
          setTName(response.data.tournament.meet_name);
          setSports(response.data.tournament.sports_type);
        }
      });
    } else if (localStorage.getItem("Role") === "7") {
      coachtourviewdetail(id).then((response) => {
        if (response.status === true && response.data.tournament !== null) {
          setTName(response.data.tournament.meet_name);
          setSports(response.data.tournament.sports_type);
        }
      });
    } else if (localStorage.getItem("Role") === "8") {
      tourdetails(id).then((response) => {
        if (response.status === true && response.data.tournament !== null) {
          setTName(response.data.tournament.meet_name);
          setSports(response.data.tournament.sports_type);
        }
      });
    }
    if (tid != 0) {
      pooldetails(tid).then((response) => {
        if (response.status === true) {
          setPName(response.data.pool_name);
        }
      });
    }
  }, []);

  function listall() {
    tourpointslist(id, eid, tid).then((response) => {
      if (response.status === true) {
        setFilterProduct(response.data);
      }
    });
  }

  function pointsentry() {
    dotracking(
      "upload points button in points list for " +
        catname +
        " (" +
        eid +
        ") category in " +
        tname +
        " (" +
        id +
        ") tournament $$ " +
        trackobj.pointuploadheading
    );
    if (localStorage.getItem("Role") === "1") {
      navigate("/superadmin/pointsentry/" + id + "/" + eid + "/" + tid);
    }
  }

  function backlist() {
    if (localStorage.getItem("Role") !== "6") {
      if (tid == 0) {
        dotracking(
          catname +
            " (" +
            eid +
            ") category back button in points list for " +
            tname +
            " (" +
            id +
            ") tournament $$ " +
            trackobj.categorylistheading
        );
      } else {
        dotracking(
          plname +
            " (" +
            tid +
            ") pool in " +
            catname +
            " (" +
            eid +
            ") category back button in points list for " +
            tname +
            " (" +
            id +
            ") tournament $$ " +
            trackobj.poollistheading
        );
      }
    } else {
      dotracking(
        catname +
          " (" +
          eid +
          ") category back button in points list for " +
          tname +
          " (" +
          id +
          ") tournament $$ " +
          trackobj.reglistheading
      );
    }
    if (tid == 0) {
      if (localStorage.getItem("Role") === "1") {
        navigate("/superadmin/categorylist/" + id);
      } else if (localStorage.getItem("Role") === "3") {
        navigate("/cityregional/categorylist/" + id);
      } else if (localStorage.getItem("Role") === "4") {
        navigate("/schoolhead/categorylist/" + id);
      } else if (localStorage.getItem("Role") === "5") {
        navigate("/referee/categorylist/" + id);
      } else if (localStorage.getItem("Role") === "6") {
        navigate("/player/registeredlist");
      } else if (localStorage.getItem("Role") === "7") {
        navigate("/coach/categorylist/" + id);
      } else if (localStorage.getItem("Role") === "8") {
        navigate("/funder/categorylist/" + id);
      }
    } else {
      if (localStorage.getItem("Role") === "1") {
        navigate("/superadmin/poollist/" + id + "/" + eid);
      } else if (localStorage.getItem("Role") === "3") {
        navigate("/cityregional/poollist/" + id + "/" + eid);
      } else if (localStorage.getItem("Role") === "4") {
        navigate("/schoolhead/poollist/" + id + "/" + eid);
      } else if (localStorage.getItem("Role") === "5") {
        navigate("/referee/poollist/" + id + "/" + eid);
      } else if (localStorage.getItem("Role") === "6") {
        navigate("/player/registeredlist");
      } else if (localStorage.getItem("Role") === "7") {
        navigate("/coach/poollist/" + id + "/" + eid);
      } else if (localStorage.getItem("Role") === "8") {
        navigate("/funder/poollist/" + id + "/" + eid);
      }
    }
  }

  function deleteptslist() {
    Swal.fire({
      title: "Are you sure want to delete?",
      showCancelButton: true,
      confirmButtonColor: "#d71635",
      confirmButtonText: "Ok",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        const tempData = new FormData();
        tempData.append("tournament_meet_id", id);
        tempData.append("category_id", eid);
        dotracking(
          catname +
            " (" +
            eid +
            ") category delete points button in points list for " +
            tname +
            " (" +
            id +
            ") tournament $$ " +
            trackobj.pointlistheading
        );
        pointswholedelete(tempData).then((res) => {
          if (res.status === true) {
            toast.success(res.message);
            listall();
          }
        });
      }
    });
  }

  return (
    <div className="side-app">
      <div className="page-header">
        <div className="breadcrumb">
          <h4 className="mb-0">Points List</h4>
        </div>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Tournament</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Tournament Points List
          </li>
        </ol>
      </div>

      <div className="row">
        <div className="col-12">
          <form className="card mt-0">
            <div className="card-body">
              <div className="row">
                <div className="col-md-7 align-self-center">
                  <h3>{tname}</h3>
                  <h4 className="text-success tx-20">Category - {catname}</h4>
                  {tid != 0 && (
                    <h4 className="text-warning tx-20">Pool - {plname}</h4>
                  )}
                </div>
                <div className="col-md-5">
                  <div className="text-right">
                    {localStorage.getItem("Role") === "1" && (
                      <>
                        {tid == 0 && (
                          <a
                            className="btn btn-danger me-2 mt-1"
                            onClick={deleteptslist}
                          >
                            <i className="fa fa-trash"></i> Delete Points
                          </a>
                        )}

                        <a
                          className="btn btn-success me-2 mt-1"
                          onClick={pointsentry}
                        >
                          <i className="fa-solid fa-upload"></i> Points Upload
                        </a>
                      </>
                    )}
                    <a className="btn btn-gray me-2 mt-1" onClick={backlist}>
                      <i className="fe fe-corner-up-left"></i> Back
                    </a>
                  </div>
                </div>
              </div>

              <div className="ag-theme-alpine ag-style mt-2">
                <AgGridReact
                  columnDefs={sports.toUpperCase() === "CRICKET" ? columnCDefs : sports.toUpperCase() === "CHESS" ? columnChDefs : columnDefs}
                  rowData={filterProduct}
                  pagination="true"
                  paginationPageSize="10"
                  sortingOrder={sorting}
                  suppressExcelExport={true}
                  suppressDragLeaveHidesColumns={true}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
